const convertTypeLoan = (type) => {
  let response = type;
  switch (type) {
    case "DECREASE_INTEREST":
      response = "ດອກເບ້ຍຫຼຸດລົງ";
      break;
    case "CONSTANT_INTEREST":
      response = "ຊຳລະດອກເບ້ຍລາຍເດືອນ, ຕົ້ນທຶນຊຳລະຕາມໄລຍະ ສິ້ນສຸດທີ່ສັນຍາກຳນົດ";
      break;
    case "CLOSURE_INTEREST":
      response = "ຊຳລະດອກເບ້ຍ ຕາມໄລຍະສິ້ນສຸດທີ່ສັນຍາກຳນົດ ພ້ອມຕົ້ນທຶນ";
      break;
    case "ALL_CONSTANT_INTEREST":
      response ="ຕົ້ນທືນ ເເລະ ດອກເບ້ຍຄົງທີ່";
      break
    default:
    // code block
  }
  return response;
};

export default convertTypeLoan;
